'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/_opy_VqP/0/cw/ws/uvocorp.com/gatsby/~/react-slick/lib/index.js
// module id = 491
// module chunks = 35783957827783